// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"062c7d85","498":"662a7dbc","703":"28656b07","787":"df9ca789"}[chunkId] + ".chunk.js";
};